import React, { useState } from 'react';

// Reusable circled-i tooltip for the GPS Formulaires feature: a small ⓘ trigger
// that reveals a dark bubble on hover/focus/click. Matches the standalone's
// tooltip styling (dark bubble, white text). Inline by default so it can sit next
// to a heading, a metric label or a table-header cell.
const InfoTooltip = ({ text, label = 'Plus d\'informations', className = '', width = 'w-64' }) => {
  const [open, setOpen] = useState(false);

  if (!text) return null;

  return (
    <span
      className={`relative inline-flex items-center align-middle cursor-help ${className}`}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        type="button"
        aria-label={label}
        className="inline-flex items-center justify-center text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300 transition-colors focus:outline-none focus:ring-2 focus:ring-violet-400 rounded-full"
        onClick={(e) => { e.stopPropagation(); setOpen((v) => !v); }}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-3.5 w-3.5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </button>

      {open && (
        <span
          role="tooltip"
          className={`absolute left-1/2 -translate-x-1/2 top-full mt-1.5 ${width} p-2.5 bg-gray-800 text-white text-xs font-normal leading-snug rounded-md shadow-lg z-50 text-left normal-case tracking-normal pointer-events-none`}
        >
          {text}
        </span>
      )}
    </span>
  );
};

export default InfoTooltip;
